import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import * as React from 'react';

interface FeatureItemProps {
  icon: LucideIcon;
  title: ReactNode;
  description: string;
  isHighlighted?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const FeatureItem = ({
  icon: Icon,
  title,
  description,
  onMouseEnter,
  onMouseLeave,
}: FeatureItemProps) => (
  <div
    className="flex items-start gap-4 cursor-pointer transition-all duration-100 hover:pl-4 group"
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <div className="flex-shrink-0 flex items-center justify-center size-10 rounded-full bg-halfmast-1100 text-primary border">
      <Icon className="size-5" />
    </div>
    <div>
      <dt className="text-lg font-semibold text-white group-hover:underline group-hover:underline-offset-5 decoration-primary decoration-2">
        {title}
      </dt>
      <dd className="mt-1 text-base text-muted-foreground">{description}</dd>
    </div>
  </div>
);
